export default __webpack_public_path__ + "static/media/sep-line.74f8d233.svg";